import React from "react";
import { useAppConfig } from "@/appConfig";
import { isMlsRestrictedTenant } from "@/helpers/tenant";
import './low_data_state.scss'

const LowDataState = ({ tier, matchCount }) => {
  const { tenant } = useAppConfig() || {};
  const isBLS = isMlsRestrictedTenant(tenant);

  if (tier === 3) {
    return (
      <div className="low-data-state">
        <div className="low-data-state__count">
          <span className="low-data-state__number">{matchCount}</span>
          <span className="low-data-state__label">
            {matchCount === 1 ? "Match" : "Matches"}
          </span>
        </div>
        <p className="low-data-state__message">
          More buyers are posting Want-Listings daily. We'll alert you when new matches appear.
        </p>
      </div>
    );
  }

  // Tier 4 - zero matches
  const tier4Message = isBLS
    ? "You'll be notified when there are buyer Want-Listings that match your property."
    : "You'll be notified when buyers post Want-Listings that match your property.";

  return (
    <div className="low-data-state low-data-state--notice">
      <div className="low-data-state__icon">
        <svg width="20" height="20" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M16 10V18"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="16" cy="22" r="1" fill="currentColor" />
        </svg>
      </div>
      <p className="low-data-state__message">
        {tier4Message}
      </p>
    </div>
  );
};

export default LowDataState;
